export var SingularPaymentStatus;
(function (SingularPaymentStatus) {
    SingularPaymentStatus["PENDING"] = "PENDING";
    SingularPaymentStatus["PAID"] = "PAID";
    SingularPaymentStatus["FAILED"] = "FAILED";
    SingularPaymentStatus["EXPIRED"] = "EXPIRED";
})(SingularPaymentStatus || (SingularPaymentStatus = {}));
